import { createContext, useContext, useState } from "react";
const SupplierContext = createContext();

export const SupplierProvider = ({ children }) => {
  const [totalAmountFornecedorA, setTotalAmountFornecedorA] = useState(0)
  const [totalAmountFornecedorB, setTotalAmountFornecedorB] = useState(0)
  const [totalAmountFornecedorC, setTotalAmountFornecedorC] = useState(0)

  return (
    <SupplierContext.Provider
      value={{
        totalAmountFornecedorA,
        totalAmountFornecedorB,
        totalAmountFornecedorC,
        setTotalAmountFornecedorA,
        setTotalAmountFornecedorB,
        setTotalAmountFornecedorC
      }}
    >
      {children}
    </SupplierContext.Provider>
  );
};

export const useSupplier = () => useContext(SupplierContext);
